import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout for /dashboard/tenants — the registry lives in ./tenants/index.tsx, the detail in
// ./tenants/$tenantPublicId.tsx. This must render an <Outlet/> or child routes (tenant detail)
// are masked by the registry.
export const Route = createFileRoute("/(app)/dashboard/tenants")({
  component: () => <Outlet />,
});
